// Types
import LineItem from './types/LineItem'
import RETURN_MODES from './types/ReturnModes'
import PRODUCT_RETURN_REASON_CODE from './types/productReturnReasonCode'
import { ProductReturnCard, ProductReturnData } from './types/useReturnController.types'

import Order from './types/Order'
import Photo, { IMAGE_UPLOAD_STATUS, ImageUploadResponse } from './types/Photo'
import REFUND_TYPES from './types/RefundTypes'

// Helpers
import { makeReturnLineItems } from './useReturnController.helpers'

// Hooks
import useReturnController, { RETURN_STAGE_NO_VS_NAME } from './useReturnController'

export default useReturnController

export {
  IMAGE_UPLOAD_STATUS,
  PRODUCT_RETURN_REASON_CODE,
  REFUND_TYPES,
  RETURN_MODES,
  RETURN_STAGE_NO_VS_NAME,
  makeReturnLineItems,
  type ImageUploadResponse,
  type LineItem,
  type Order,
  type Photo,
  type ProductReturnCard,
  type ProductReturnData,
}
